// Accessible client-side ordering for Pioniers archive
// - Sort by title (A-Z / Z-A)
// - Sort by birth year extracted from .card-pionier--levensjaren (leading 4 digits)

(function () {
  const form = document.getElementById("order-pioniers");
  if (!form) return;

  // Find the results grid (siblings inside the same block wrapper)
  // Assumes structure from archive-pioniers.php
  const blockWrapper = form.closest(".block--wrapper");
  const grid = blockWrapper ? blockWrapper.querySelector(".grid") : null;
  if (!grid) return;

  // Ensure base select exists, add id/name and label for a11y
  const fieldSelect = form.querySelector("select");
  if (!fieldSelect) return;

  // Capture original order to restore when empty option is selected
  function getItems() {
    return Array.from(grid.children).filter((el) => el.nodeType === 1);
  }
  const originalOrder = getItems();

  function renderOrder(list) {
    const fragment = document.createDocumentFragment();
    list.forEach((wrapper) => fragment.appendChild(wrapper));
    grid.appendChild(fragment);
  }

  function normalizeString(value) {
    return (value || "").toString().trim().toLocaleLowerCase();
  }

  function extractTitle(cardEl) {
    const titleEl = cardEl.querySelector("h3");
    return titleEl ? normalizeString(titleEl.textContent) : "";
  }

  function extractYear(cardEl) {
    const yearsEl = cardEl.querySelector(".card-pionier--levensjaren");
    if (!yearsEl) return NaN;
    const text = yearsEl.textContent || "";
    const match = text.match(/\b(\d{4})/);
    return match ? parseInt(match[1], 10) : NaN;
  }

  function sortItems() {
    const value = fieldSelect.value; // e.g., "naam-asc", "jaar-desc"
    if (!value) {
      // Restore original order when empty/default is selected
      renderOrder(originalOrder);
      return;
    }
    const [field, direction] = value.split("-");
    const multiplier = direction === "desc" ? -1 : 1;

    const items = getItems();
    const withKeys = items.map((wrapper, index) => {
      const card = wrapper.querySelector(".card-pionier") || wrapper;
      let keyPrimary;
      if (field === "jaar") {
        keyPrimary = extractYear(card);
      } else {
        keyPrimary = extractTitle(card);
      }
      return { wrapper, index, keyPrimary };
    });

    withKeys.sort((a, b) => {
      if (field === "jaar") {
        const aYear = isNaN(a.keyPrimary) ? null : a.keyPrimary;
        const bYear = isNaN(b.keyPrimary) ? null : b.keyPrimary;

        if (aYear === null && bYear === null) return a.index - b.index;
        if (aYear === null) return 1; // push unknowns to end
        if (bYear === null) return -1;
        return (aYear - bYear) * multiplier;
      }
      // naam
      const aName = a.keyPrimary;
      const bName = b.keyPrimary;
      if (aName === bName) return a.index - b.index;
      return aName.localeCompare(bName, undefined, { sensitivity: "base" }) * multiplier;
    });

    // Re-append in sorted order
    renderOrder(withKeys.map(({ wrapper }) => wrapper));
  }

  fieldSelect.addEventListener("change", sortItems);

  // Initial sort (respect whatever the current selection is)
  if (fieldSelect.value) {
    sortItems();
  }
})();
